import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_sidebar-layout/contact')({
  component: () => <div>Hello /_layout/contact!</div>,
});
